/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/tabSlice"; // Import the setActiveTab action
import Loader from "../../../components/Loader";
import ActivityTabsHeader from "../../../components/StudentDashboard/ActivityTabsHeader/ActivityTabsHeader";
import { Button } from "react-bootstrap";
import AttemptDialog from "../Practice/AttemptDialog";
import withSubscriptionCheckButton from "../../../components/Common/withSubscriptionCheckButton";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../../store/userRole";

// Components
import DesktopView from "./components/DesktopView";
import MobileView from "./components/MobileView";
import Sidebar from "./components/Sidebar";

// Utils
import { isTestAccessible, renderTestButton } from "./utils/testUtils";
import {
  onAttemptHandler,
  onViewAllAttempts,
  onViewAttempts,
} from "./utils/navigationUtils";
import {
  getClassroomDetails,
  getTopicwiseTestListOfSubject,
  setupSidebar,
} from "./utils/classroomUtils";

const StartButton = withSubscriptionCheckButton(
  Button,
  "Topic-wise Tests",
  true
);

const TopicwiseTest = ({ isMobileView, hasValidSubscription }) => {
  const roleOfTheUser = useSelector(getUserRole);
  const [isLoading, setIsLoading] = useState(true);
  const [classroomName, setClassroomName] = useState("");
  const [classroomLoader, setClassroomLoader] = useState(true);
  const { id: classroomId } = useParams();
  const activeTab = useSelector((state) => state.tab.activeTab); // Get activeTab from Redux
  const [tabsList, setTabsList] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [sectionsList, setSectionsList] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedMobileTopic, setSelectedMobileTopic] = useState([]);
  const [modules, setModules] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTopicId, setSelectedTopicId] = useState("");
  const [selectedTest, setSelectedTest] = useState({});

  const [topicsList, setTopicsList] = useState([]);
  const navigate = useNavigate();

  const rolePermissions = useSelector(getUserPermission);
  const userInformation = useSelector(getUserInformation);
  const [createdBy, setCreatedBy] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  const isNotifyConfig = queryParams.get("notificationConfig");
  const notifySub = queryParams.get("subj");
  const notifySec = queryParams.get("sec");
  const notifyTopic = queryParams.get("topic");
  const notifyExam = queryParams.get("examId");
  const [focusedExam, setFocusExam] = useState("");

  const isFirstRef = useRef(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      isNotifyConfig &&
      isNotifyConfig === "true" &&
      isFirstRef.current === false &&
      sectionsList?.length
    ) {
      isFirstRef.current = true;
      setActiveTab(notifySub);
      setSelectedSections([notifySec]);
      if (isMobileView) {
        setSelectedMobileTopic([notifyTopic]);
      } else {
        setSelectedTopic(notifyTopic);
        scrollToTopic(notifyTopic);
      }
      setFocusExam(notifyExam);
      setTimeout(() => {
        setFocusExam("");
      }, [3000]);
    }
  }, [isNotifyConfig, sectionsList]);

  useEffect(() => {
    getClassroomDetails(
      classroomId,
      setClassroomName,
      setModules,
      setCreatedBy,
      setCourseId,
      setTabsList,
      setClassroomLoader,
      activeTab,
      dispatch
    );
  }, [classroomId]);

  useEffect(() => {
    if (activeTab) {
      dispatch(setActiveTab(activeTab));
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    setupSidebar(
      classroomId,
      classroomName,
      createdBy,
      dispatch,
      modules,
      roleOfTheUser,
      rolePermissions,
      userInformation
    );
  }, [
    classroomId,
    classroomName,
    createdBy,
    dispatch,
    modules,
    roleOfTheUser,
    rolePermissions,
    userInformation?._id,
  ]);

  useEffect(() => {
    if (activeTab !== "" && courseId) {
      getTopicwiseTestListOfSubject(
        classroomId,
        courseId,
        activeTab,
        setSectionsList,
        setSelectedSections,
        setSelectedTopic,
        setSelectedMobileTopic,
        setTopicsList,
        setIsLoading
      );
    }
  }, [activeTab, courseId]);

  const scrollToTopic = useCallback((topicId) => {
    const topicElement = document.getElementById(topicId);
    if (topicElement) {
      topicElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);

  useEffect(() => {
    if (!topicsList.length) return;

    const checkTestsAccessibility = () => {
      const newAccessibleTests = new Set();
      topicsList.forEach((topic) => {
        topic.tests?.forEach((test) => {
          if (isTestAccessible(test)) {
            newAccessibleTests.add(test._id);
          }
        });
      });
    };

    checkTestsAccessibility();
    const interval = setInterval(checkTestsAccessibility, 1000);
    return () => clearInterval(interval);
  }, [topicsList]);

  if (isLoading || classroomLoader) {
    return <Loader />;
  }

  return (
    <div>
      {open && (
        <AttemptDialog
          open={open}
          onAttempt={() =>
            onAttemptHandler(
              navigate,
              roleOfTheUser,
              classroomId,
              activeTab,
              selectedTopicId,
              selectedTest
            )
          }
          onViewAttempts={() =>
            onViewAttempts(
              navigate,
              roleOfTheUser,
              classroomId,
              activeTab,
              selectedTest
            )
          }
          setOpen={setOpen}
          classroomId={classroomId}
          topicId={selectedTopicId}
          practice={selectedTest}
        />
      )}
      <div style={{ position: "sticky", top: "-1px", zIndex: 6 }}>
        <ActivityTabsHeader
          isMobileView={isMobileView}
          tabsList={tabsList}
          activeTab={activeTab}
          onTabChange={(newTab) => dispatch(setActiveTab(newTab))}
        />
      </div>
      <div className="row m-0">
        <Sidebar
          sectionsList={sectionsList}
          selectedSections={selectedSections}
          setSelectedSections={setSelectedSections}
          selectedTopic={selectedTopic}
          setSelectedTopic={setSelectedTopic}
          selectedMobileTopic={selectedMobileTopic}
          setSelectedMobileTopic={setSelectedMobileTopic}
          scrollToTopic={scrollToTopic}
          roleOfTheUser={roleOfTheUser}
          classroomId={classroomId}
          activeTab={activeTab}
          hasValidSubscription={hasValidSubscription}
          onViewAllAttempts={() =>
            onViewAllAttempts(navigate, roleOfTheUser, classroomId, activeTab)
          }
          isLoading={isLoading}
          classroomLoader={classroomLoader}
          isMobileView={isMobileView}
        />
        <DesktopView
          topicsList={topicsList}
          selectedTopic={selectedTopic}
          focusedExam={focusedExam}
          renderTestButton={(test, topic, testInd) =>
            renderTestButton(
              test,
              topic,
              testInd,
              roleOfTheUser,
              StartButton,
              Button,
              setSelectedTopicId,
              setSelectedTest,
              setOpen,
              classroomId,
              hasValidSubscription,
              activeTab
            )
          }
        />
        <MobileView
          sectionsList={sectionsList}
          selectedSections={selectedSections}
          setSelectedSections={setSelectedSections}
          selectedMobileTopic={selectedMobileTopic}
          setSelectedMobileTopic={setSelectedMobileTopic}
          roleOfTheUser={roleOfTheUser}
          classroomId={classroomId}
          activeTab={activeTab}
          hasValidSubscription={hasValidSubscription}
          onViewAllAttempts={() =>
            onViewAllAttempts(navigate, roleOfTheUser, classroomId, activeTab)
          }
          isLoading={isLoading}
          classroomLoader={classroomLoader}
          renderTestButton={(test, topic, testInd) =>
            renderTestButton(
              test,
              topic,
              testInd,
              roleOfTheUser,
              StartButton,
              Button,
              setSelectedTopicId,
              setSelectedTest,
              setOpen,
              classroomId,
              hasValidSubscription,
              activeTab
            )
          }
        />
      </div>
    </div>
  );
};

export default memo(TopicwiseTest);
